import { render, staticRenderFns } from "./ColumnSpacer.vue?vue&type=template&id=530245ba&"
import script from "./ColumnSpacer.vue?vue&type=script&lang=ts&"
export * from "./ColumnSpacer.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnSpacer.vue?vue&type=style&index=0&id=530245ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports